import { Configuration, PopupRequest } from '@azure/msal-browser'

// These env vars must match the root app exactly —
// same Azure AD app registration, same tenant.
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    // localStorage is critical — this is how the child app finds
    // the token the root app already acquired without a new login.
    cacheLocation: 'localStorage',
  },
}

export const loginRequest: PopupRequest = {
  scopes: [process.env.REACT_APP_CLIENT_ID + '/.default'],
}
